module.exports = __webpack_public_path__ + "img/trendyol.b621a72f.png";